var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[(_vm.isLoading)?_c('NanLoading'):[_c('b-alert',{attrs:{"show":!!_vm.error,"variant":"danger"}},[_vm._v(_vm._s(_vm.error))]),_c('b-alert',{attrs:{"show":!!_vm.isRedirecting,"variant":"success"}},[_vm._v("Success! Redirecting...")])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }